import * as React from "react";

const CENTaxonomySearchIcon: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20.5887 18.5978L16.3804 14.3896C17.3374 12.969 17.8096 11.1939 17.5568 9.30253C17.1258 6.08538 14.489 3.46729 11.2687 3.05959C6.48078 2.45374 2.45469 6.47983 3.06057 11.2678C3.46838 14.4895 6.08682 17.1283 9.30433 17.5572C11.1957 17.81 12.9711 17.338 14.3914 16.3809L18.5997 20.5891C19.1488 21.1382 20.0393 21.1382 20.5884 20.5891C21.1371 20.0392 21.1371 19.1463 20.5887 18.5978ZM5.78082 10.3115C5.78082 7.83018 7.7995 5.81151 10.2808 5.81151C12.7622 5.81151 14.7808 7.83018 14.7808 10.3115C14.7808 12.7928 12.7622 14.8115 10.2808 14.8115C7.7995 14.8115 5.78082 12.7935 5.78082 10.3115Z"
                fill="#262525"
            />
        </svg>
    );
};

export default React.memo(CENTaxonomySearchIcon);
